import { LANGUAGE_DEFAULT, LANGUAGES, LOCAL_STORAGE_ITEMS } from "./constants";

export const noOp = () => undefined;

export const isFunction = (obj) =>
  !!(obj && obj.constructor && obj.call && obj.apply);

export const isString = (string) =>
  typeof string === "string" || string instanceof String;

export const formatTime = (timeline) => {
  const date = new Date(timeline * 1000);

  const hours = date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`;
  const minutes =
    date.getMinutes() > 10 ? date.getMinutes() : `0${date.getMinutes()}`;
  const seconds =
    date.getSeconds() > 10 ? date.getSeconds() : `0${date.getSeconds()}`;

  return `${hours}:${minutes}:${seconds}`;
};

export const formatHour = (ts) => {
  if (!ts) return "";
  let date;
  if (typeof ts === "number") {
    date = new Date(ts < 1e12 ? ts * 1000 : ts);
  } else {
    const n = Number(ts);
    if (!Number.isNaN(n)) {
      date = new Date(n < 1e12 ? n * 1000 : n);
    } else {
      date = new Date(ts);
    }
  }
  if (isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: false });
};

const isLocalStorageAvailable = () => {
  try {
    const testKey = '__test__';
    localStorage.setItem(testKey, 'test');
    localStorage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

const isNavigator = typeof navigator !== 'undefined';

const userLanguage = isNavigator && isLocalStorageAvailable() ?
    localStorage.getItem(LOCAL_STORAGE_ITEMS.LOCALE) ||
    navigator.language.split(/[-_]/)[0] : LANGUAGE_DEFAULT;

export const language = LANGUAGES.includes(userLanguage) ? userLanguage : LANGUAGE_DEFAULT;